import React from 'react';
import { Modal, Button, Table } from 'antd';

export default class HistoryModal extends React.Component {
	state = { modalOpen: false }
	render() {
		return (
			<div>
				<Button icon="clock-circle-o" onClick={e => this.setState({ modalOpen: !this.state.modalOpen })} />
				<Modal visible={this.state.modalOpen} closable={false} width="100%" footer={[
					<Button onClick={() => this.setState({ modalOpen: false })}>Close</Button>
				]}>
					<Table
						size="small"
						pagination={false}
						columns={[
							{title: 'Amount', dataIndex: 'amount'},
							{title: 'Status', dataIndex: 'status'},
							{title: 'Updated by', dataIndex: 'awarded_by'},
							{title: 'Awarded date', dataIndex: 'awarded_date'},
							{title: 'Accepted/Declined', dataIndex: 'accepted_date',
								render: (value, record) => (value)?'by '+record.accepted_by+' on '+value:''},
							{title: 'Resco Status', dataIndex: 'resco_synced', variants: ['admin'],
								render: value => (value === "0")? 'Not synced':'Synced'},
							{title: 'Note', dataIndex: 'note'}
						]}
						dataSource={[this.props.current].concat(this.props.history)}
					/>
				</Modal>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/FinancialAid/HistoryModal.jsx